module.exports = __webpack_public_path__ + "static/media/favicon.01ae4a36.ico";